var _g, _rect, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 71,
    viewBox: "0 0 72 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66,
    filter: "url(#filter0_f_3870_45831)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 11,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "url(#paint0_linear_3870_45831)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3870_45831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.957 45.1866C30.858 43.6786 29.5 41.4016 29.5 38.9096C29.5 34.3246 33.975 30.6016 39.5 30.6016C45.025 30.6016 49.5 34.3246 49.5 38.9096C49.5 43.4936 45.025 47.2166 39.5 47.2166C38.3927 47.2232 37.2904 47.0679 36.228 46.7556C36.136 46.7256 36.012 46.7256 35.92 46.7256C35.735 46.7256 35.55 46.7856 35.395 46.8786L33.204 48.1396C33.1478 48.1738 33.0845 48.195 33.019 48.2016C32.9293 48.201 32.8435 48.1653 32.7799 48.1021C32.7163 48.0389 32.68 47.9532 32.679 47.8636C32.679 47.7706 32.709 47.7096 32.741 47.6166C32.771 47.5866 33.049 46.5706 33.204 45.9556C33.204 45.8936 33.234 45.8016 33.234 45.7396C33.234 45.4936 33.142 45.3096 32.957 45.1866ZM36.167 37.5126C36.884 37.5126 37.452 36.9446 37.452 36.2276C37.452 35.5096 36.884 34.9416 36.167 34.9416C35.449 34.9416 34.882 35.5096 34.882 36.2276C34.882 36.9446 35.449 37.5126 36.167 37.5126ZM42.833 37.5126C43.551 37.5126 44.118 36.9446 44.118 36.2276C44.118 35.5096 43.551 34.9416 42.833 34.9416C42.116 34.9416 41.548 35.5096 41.548 36.2276C41.548 36.9446 42.116 37.5126 42.833 37.5126Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 1,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint1_linear_3870_45831)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3870_45831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.457 35.1866C27.358 33.6786 26 31.4016 26 28.9096C26 24.3246 30.475 20.6016 36 20.6016C41.525 20.6016 46 24.3246 46 28.9096C46 33.4936 41.525 37.2166 36 37.2166C34.8927 37.2232 33.7904 37.0679 32.728 36.7556C32.636 36.7256 32.512 36.7256 32.42 36.7256C32.235 36.7256 32.05 36.7856 31.895 36.8786L29.704 38.1396C29.6478 38.1738 29.5845 38.195 29.519 38.2016C29.4293 38.201 29.3435 38.1653 29.2799 38.1021C29.2163 38.0389 29.18 37.9532 29.179 37.8636C29.179 37.7706 29.209 37.7096 29.241 37.6166C29.271 37.5866 29.549 36.5706 29.704 35.9556C29.704 35.8936 29.734 35.8016 29.734 35.7396C29.734 35.4936 29.642 35.3096 29.457 35.1866ZM32.667 27.5126C33.384 27.5126 33.952 26.9446 33.952 26.2276C33.952 25.5096 33.384 24.9416 32.667 24.9416C31.949 24.9416 31.382 25.5096 31.382 26.2276C31.382 26.9446 31.949 27.5126 32.667 27.5126ZM39.333 27.5126C40.051 27.5126 40.618 26.9446 40.618 26.2276C40.618 25.5096 40.051 24.9416 39.333 24.9416C38.616 24.9416 38.048 25.5096 38.048 26.2276C38.048 26.9446 38.616 27.5126 39.333 27.5126Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3870_45831",
    x: 0.5,
    y: 0,
    width: 71,
    height: 71,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_3870_45831"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3870_45831",
    x1: 36,
    y1: 11,
    x2: 36,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FD9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3870_45831",
    x1: 36,
    y1: -3.18265,
    x2: 39.1427,
    y2: 68.8102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C9FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#FD9900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3870_45831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(27.5 27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3870_45831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.cd3cf8e3db63934b912911fb7e422ee2.svg";
export { ForwardRef as ReactComponent };